import React, { useState } from "react";
import "./Signup.css";
import { Link } from "react-router-dom";
import googleLogo from "../../icons/googleLogo.png";
import fbLogo from "../../icons/fbLogo.png";
import config from "../../config/apiConfig";
import auth_info from '../../icons/auth_info.png';
import ReactGA from 'react-ga';

function Signup() {
    const [username, setUsername] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [error, setError] = useState("");

    function handleChange(e) {
        e.preventDefault();
        if (e.target.name === "username") {
            setUsername(e.target.value);
        } else if (e.target.name === "email") {
            setEmail(e.target.value);
        } else if (e.target.name === "password") {
            setPassword(e.target.value);
        } else if (e.target.name === "confirmPassword") {
            setConfirmPassword(e.target.value);
        }
    }

    function handleSignup(e) {
        e.preventDefault();
        if (password !== confirmPassword) {
            setError("Passwords didn't match");
            return;
        }
        const formData = new FormData();
        formData.append("name", username);
        formData.append("email", email);
        formData.append("password", password);
        formData.append("gender", "male");
        formData.append("date_of_birth", "2002-04-24");
        formData.append("token", config.token);
        formData.append("device", "web");
        formData.append("session-token", "AUTH");
        const requestOptions = {
            method: "POST",
            body: formData,
        };
        fetch(config.BASE_URL + "/idam/user/signup", requestOptions)
            .then((res) => res.json())
            .then((resp) => {
                if (resp.is_error) setError(resp.error_msg);
                else setError(resp.info_msg);
                ReactGA.event({
                    category: 'AUTH',
                    action: 'Created New Account',
                    label: email
                });
            })
            .catch((err) => console.log(err));
    }

    return (
        <div style={{ background: "#0d0d0d", padding: "129px 0" }}>
            <div className="login">
                <div className="login__left">
                    <div className="login__header">
                        <h2 style={{ fontSize: "26px" }}>
                            Create your account
                        </h2>
                        <p>Sign up on Pencil</p>
                    </div>
                    <div className="auth__box__signup">
                        <img src={auth_info} alt="" />
                    </div>
                    <div style={{ color: "rgba(0, 0, 0, 0.4)" }}>
                        Already have an account?{" "}
                        <Link to="/login">
                            <span style={{ color: "#3172ed" }}>Sign In</span>
                        </Link>
                    </div>
                </div>
                <div className="login__right">
                    <form className="login__form" id="form" method="post">
                        <label>
                            NAME
                            <input
                                type="text"
                                className="login__input"
                                name="username"
                                value={username}
                                onChange={handleChange}
                                placeholder="Enter name here"
                            />
                        </label>
                        <label>
                            EMAIL
                            <input
                                type="text"
                                className="login__input"
                                name="email"
                                value={email}
                                onChange={handleChange}
                                placeholder="Enter email here"
                            />
                        </label>
                        <label>
                            PASSWORD
                            <input
                                type="password"
                                className="login__input"
                                name="password"
                                value={password}
                                onChange={handleChange}
                                placeholder="Enter your password"
                            />
                        </label>
                        <label>
                            CONFIRM PASSWORD
                            <input
                                type="password"
                                className="login__input"
                                name="confirmPassword"
                                value={confirmPassword}
                                onChange={handleChange}
                                placeholder="Confirm your password"
                            />
                        </label>
                        <button
                            className="login__button"
                            onClick={handleSignup}
                        >
                            Sign up now
                        </button>
                        <p className="login__error">{error}</p>
                        <div
                            style={{
                                width: "100%",
                                height: 0,
                                margin: "16px 0 8px",
                                opacity: 0.09,
                                border: "solid 1px #707070",
                            }}
                        ></div>
                        <div className="flex__wrapper">
                            <p
                                style={{
                                    fontSize: "12px",
                                    margin: "0 16px 0 0",
                                }}
                            >
                                SIGN UP VIA
                            </p>
                            <div className="socialBtns">
                                <div id="fbLogo">
                                    <img src={fbLogo} />
                                </div>
                                <div id="googleLogo">
                                    <img src={googleLogo} />
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default Signup;
